import { Injector, Pipe, PipeTransform } from '@angular/core';

import { Countries } from '../../../assets/countries/countries.js';
import { TranslateService } from '@ngx-translate/core';
import { LanguageEnum } from 'src/app/core/common';
@Pipe({
  standalone: true,
  name: 'countryName',
})
export class CountryNamePipe implements PipeTransform {
  constructor(private injector: Injector) {}
  transform(countryCode: string): string {
    const language: LanguageEnum = this.injector.get(TranslateService).currentLang as LanguageEnum;
    if (language == LanguageEnum.Arabic) {
      return Countries?.find((country) => country.code.toLowerCase() == countryCode.toLowerCase()).arabicName;
    } else {
      return Countries?.find((country) => country.code.toLowerCase() == countryCode.toLowerCase()).name;
    }
  }
}
